/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  InviteSiteUsersAndTeams,
  List,
  MemberRole,
  TeamSitePermissionOverride,
} from "./data-contracts";

/**
 * No description
 * @tags site-permissions
 * @name InviteToSite
 * @summary Invite a user or a team to a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/permissions
 * @secure
 */

// @ts-ignore
export const inviteToSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: InviteSiteUsersAndTeams;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions",
  method: "post",
  streaming: false,
  tags: ["site-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-permissions
 * @name ListTeamPermissionsInSite
 * @summary List an org team's permission in a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/permissions/teams
 * @secure
 */

// @ts-ignore
export const listTeamPermissionsInSite: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: TeamSitePermissionOverride[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions/teams",
  method: "get",
  streaming: false,
  tags: ["site-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-permissions
 * @name UpdateTeamPermissionInSite
 * @summary Update an org team's permission in a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const updateTeamPermissionInSite: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * "The role of a member in an organization.
     * "admin": Can administrate the content: create, delete spaces, ...
     * "create": Can create content.
     * "review": Can review content.
     * "edit": Can edit the content (live or change requests).
     * "comment": Can access the content and its discussions.
     * "read": Can access the content, but cannot update it in any way.
     */
    role?: MemberRole;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions/teams/{teamId}",
  method: "patch",
  streaming: false,
  tags: ["site-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-permissions
 * @name RemoveTeamFromSite
 * @summary Remove an org team from a site
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const removeTeamFromSite: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the Team */
    teamId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions/teams/{teamId}",
  method: "delete",
  streaming: false,
  tags: ["site-permissions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
